import React from "react";
import profile from "@src/assets/auctionAgent/expertThumbnailDefault.png";
import styled from "styled-components";
import { UserMessage } from "@sendbird/chat/message";
import { formatTimeToKorean12Hour } from "@src/util/formatTimeToKorean12Hour";

interface ReceivedMessageProps {
    createdAt: string;
    message: string;
    isDifferentSender: boolean;
    senderImage: string;
}

const ReceivedMessage = ({ createdAt, message, senderImage, isDifferentSender }: ReceivedMessageProps) => {
    const showDefault = senderImage === "" || senderImage.includes("이미지주소");
    return (
        <ContainerBox isDifferentSender={isDifferentSender}>
            {isDifferentSender ? (
                <div className="profile">
                    <img src={showDefault ? profile : senderImage} alt="profile" />
                </div>
            ) : (
                <div className="profile" />
            )}
            <ReceivedMessageBox>
                <div className="message">{message}</div>
                <div className="time">{formatTimeToKorean12Hour(createdAt)}</div>
            </ReceivedMessageBox>
        </ContainerBox>
    );
};

export default ReceivedMessage;

const ContainerBox = styled.div<{ isDifferentSender: boolean }>`
    display: flex;
    gap: 4px;
    align-items: flex-start;
    margin-top: ${(props) => (props.isDifferentSender ? "10px" : "6px")};
    .profile {
        min-width: 30px;
        min-height: 30px;
        max-width: 30px;
        max-height: 30px;
        border-radius: 50%;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
`;

const ReceivedMessageBox = styled.div`
    width: 100%;
    display: flex;
    gap: 4px;
    align-items: flex-end;

    .time {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 10px;
        color: #a3b0c6;
        min-width: fit-content;
        margin-bottom: 4px;
    }

    .message {
        font-size: 15px;
        color: #0c002c;
        background-color: #f7f8fa;
        padding: 10px;
        border-radius: 14px;
        line-height: 1.5;
    }
`;
